'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var nthHookContextAnalytics = require('@narvar/nth-hook-context-analytics');

function useLogTrackingNumberInteraction({
  id,
  trackingNumber,
  carrier = '',
  featureName = '',
  layout,
  eddConfidenceHypothesis1Enabled
}) {
  const logEvent = nthHookContextAnalytics.useAnalyticsPost();
  React.useEffect(() => {
    function handleClick(event) {
      if (!eddConfidenceHypothesis1Enabled) return;
      const target = event.target;
      const selected = window.getSelection();
      const selectedText = selected?.toString().trim();

      // Do not fire click event if the mouse event is highlighting the
      // tracking number on the page.  It is not a click, the end user is likely
      // intending to copy.
      if (selectedText && selectedText === trackingNumber) {
        logEvent({
          clickCategory: nthHookContextAnalytics.NarvarClickSubTypes.TRACKING_NUMBER,
          clickSubType: nthHookContextAnalytics.NarvarClickSubTypes.HIGHLIGHT_TEXT,
          clickType: nthHookContextAnalytics.NarvarClickTypes.INTERACTION,
          eventCarrierMoniker: carrier,
          eventComponent: nthHookContextAnalytics.NarvarEventComponents.NTH_BLOCK_CARRIER_TRACKING_LINK,
          eventFeature: nthHookContextAnalytics.NarvarEventComponents.NTH_BLOCK_CARRIER_TRACKING_LINK,
          eventTrackingNumber: trackingNumber,
          eventType: nthHookContextAnalytics.NarvarEventTypes.CLICK,
          feature: featureName,
          pageComponent: nthHookContextAnalytics.NarvarEventComponents.NTH_BLOCK_CARRIER_TRACKING_LINK,
          trackLayout: layout
        });
        return;
      }
      if (target.id !== id) return;
      logEvent({
        clickCategory: nthHookContextAnalytics.NarvarClickSubTypes.TRACKING_NUMBER,
        clickSubType: nthHookContextAnalytics.NarvarClickSubTypes.TRACKING_NUMBER,
        clickType: nthHookContextAnalytics.NarvarClickTypes.INTERACTION,
        eventCarrierMoniker: carrier,
        eventComponent: nthHookContextAnalytics.NarvarEventComponents.NTH_BLOCK_CARRIER_TRACKING_LINK,
        eventFeature: nthHookContextAnalytics.NarvarEventComponents.NTH_BLOCK_CARRIER_TRACKING_LINK,
        eventTrackingNumber: trackingNumber,
        eventType: nthHookContextAnalytics.NarvarEventTypes.CLICK,
        feature: featureName,
        pageComponent: nthHookContextAnalytics.NarvarEventComponents.NTH_BLOCK_CARRIER_TRACKING_LINK,
        trackLayout: layout
      });
    }
    document.addEventListener('click', handleClick);
    return () => {
      document.removeEventListener('click', handleClick);
    };
  }, [id, trackingNumber, carrier, featureName, layout, eddConfidenceHypothesis1Enabled, logEvent]);
  React.useEffect(() => {
    function handleCopyEvent() {
      if (!eddConfidenceHypothesis1Enabled) return;
      const selected = window.getSelection();
      const selectedText = selected?.toString().trim();
      if (selectedText !== trackingNumber) return;
      logEvent({
        clickCategory: nthHookContextAnalytics.NarvarClickSubTypes.TRACKING_NUMBER,
        clickSubType: nthHookContextAnalytics.NarvarClickSubTypes.COPIED_TEXT,
        clickType: nthHookContextAnalytics.NarvarClickTypes.INTERACTION,
        eventCarrierMoniker: carrier,
        eventComponent: nthHookContextAnalytics.NarvarEventComponents.NTH_BLOCK_CARRIER_TRACKING_LINK,
        eventFeature: nthHookContextAnalytics.NarvarEventComponents.NTH_BLOCK_CARRIER_TRACKING_LINK,
        eventTrackingNumber: trackingNumber,
        eventType: nthHookContextAnalytics.NarvarEventTypes.CLICK,
        feature: featureName,
        pageComponent: nthHookContextAnalytics.NarvarEventComponents.NTH_BLOCK_CARRIER_TRACKING_LINK,
        trackLayout: layout
      });
    }
    document.addEventListener('copy', handleCopyEvent);
    return () => {
      document.removeEventListener('copy', handleCopyEvent);
    };
  }, [trackingNumber, carrier, featureName, layout, eddConfidenceHypothesis1Enabled, logEvent]);
}

exports.useLogTrackingNumberInteraction = useLogTrackingNumberInteraction;
